import { isAudioMimeType, isDocumentMimeType, isImageMimeType, isVideoMimeType } from "helpers/fileValidation";
import { css, html, LitElement, svg, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("doc-icon")
export class DocIcon extends LitElement {
  static override styles = css`
    :host {
      display: contents;
    }
  `;

  @property({ type: String })
  type?: string;

  private colors() {
    if (!this.type) {
      return {
        back: "#6172F3",
        fold: "#C7D7FE",
      };
    }

    switch (true) {
      case this.type === "application/vnd.ms-excel":
      case this.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return {
          back: "#17B26A",
          fold: "#ABEFC6",
        };
      case this.type === "application/vnd.ms-powerpoint":
      case this.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      case this.type === "text/csv":
        return {
          back: "#F97066",
          fold: "#FECDCA",
        };

      case this.type === "application/msword":
      case this.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case this.type === "text/plain":
        return {
          back: "#444CE7",
          fold: "#C7D7FE",
        };
      case this.type === "application/pdf":
        return {
          back: "#F04438",
          fold: "#FECDCA",
        };
    }

    // Following cases will fall true less checking
    // case isImageMimeType(this.type):
    // case isVideoMimeType(this.type):
    // case isAudioMimeType(this.type):
    return {
      back: "#6172F3",
      fold: "#C7D7FE",
    };
  }

  private icon() {
    if (!this.type) {
      return nothing;
    }

    if (isImageMimeType(this.type)) {
      return svg`
        <path
          d="M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 10L10.6666 6.66669L3.33331 14"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.66669 6.66669C6.21897 6.66669 6.66669 6.21897 6.66669 5.66669C6.66669 5.1144 6.21897 4.66669 5.66669 4.66669C5.1144 4.66669 4.66669 5.1144 4.66669 5.66669C4.66669 6.21897 5.1144 6.66669 5.66669 6.66669Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      `;
    }

    if (isVideoMimeType(this.type)) {
      return svg`
        <g clip-path="url(#clip0_2001_3261)">
          <path
            d="M13.2133 1.33331H2.78665C1.98399 1.33331 1.33331 1.98399 1.33331 2.78665V13.2133C1.33331 14.016 1.98399 14.6666 2.78665 14.6666H13.2133C14.016 14.6666 14.6666 14.016 14.6666 13.2133V2.78665C14.6666 1.98399 14.016 1.33331 13.2133 1.33331Z"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.66669 1.33331V14.6666"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3333 1.33331V14.6666"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.33331 8H14.6666"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.33331 4.66669H4.66665"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1.33331 11.3333H4.66665"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3333 11.3333H14.6666"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.3333 4.66669H14.6666"
            stroke="white"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2001_3261">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      `;
    }

    if (isAudioMimeType(this.type)) {
      return svg`
        <path
          d="M4 14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10C2.89543 10 2 10.8954 2 12C2 13.1046 2.89543 14 4 14Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 12V3.33333L14 2V10.6667"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 12.6667C13.1046 12.6667 14 11.7713 14 10.6667C14 9.56212 13.1046 8.66669 12 8.66669C10.8954 8.66669 10 9.56212 10 10.6667C10 11.7713 10.8954 12.6667 12 12.6667Z"
          stroke="white"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      `;
    }

    if (isDocumentMimeType(this.type)) {
      switch (true) {
        case this.type === "application/vnd.ms-excel":
        case this.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          return svg`
            <path
              d="M2 8L14 8M2 8L2 3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2L12.6667 2C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333L14 8L2 8ZM2 8L2 12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14L12.6667 14C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667L14 8L2 8Z"
              stroke="white"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          `;
        case this.type === "text/csv":
          return svg`
            <g transform="translate(3 6) scale(1.3)">
              <path
                d="M2.92808e-06 3.24C2.92808e-06 2.616 0.135003 2.061 0.405003 1.575C0.675003 1.083 1.05 0.702001 1.53 0.432001C2.016 0.156001 2.565 0.0180006 3.177 0.0180006C3.927 0.0180006 4.569 0.216001 5.103 0.612C5.637 1.008 5.994 1.548 6.174 2.232H4.482C4.356 1.968 4.176 1.767 3.942 1.629C3.714 1.491 3.453 1.422 3.159 1.422C2.685 1.422 2.301 1.587 2.007 1.917C1.713 2.247 1.566 2.688 1.566 3.24C1.566 3.792 1.713 4.233 2.007 4.563C2.301 4.893 2.685 5.058 3.159 5.058C3.453 5.058 3.714 4.989 3.942 4.851C4.176 4.713 4.356 4.512 4.482 4.248H6.174C5.994 4.932 5.637 5.472 5.103 5.868C4.569 6.258 3.927 6.453 3.177 6.453C2.565 6.453 2.016 6.318 1.53 6.048C1.05 5.772 0.675003 5.391 0.405003 4.905C0.135003 4.419 2.92808e-06 3.864 2.92808e-06 3.24ZM9.40247 6.471C8.94047 6.471 8.52647 6.396 8.16047 6.246C7.79447 6.096 7.50047 5.874 7.27847 5.58C7.06247 5.286 6.94847 4.932 6.93647 4.518H8.57447C8.59847 4.752 8.67947 4.932 8.81747 5.058C8.95547 5.178 9.13547 5.238 9.35747 5.238C9.58547 5.238 9.76547 5.187 9.89747 5.085C10.0295 4.977 10.0955 4.83 10.0955 4.644C10.0955 4.488 10.0415 4.359 9.93347 4.257C9.83147 4.155 9.70247 4.071 9.54647 4.005C9.39647 3.939 9.18047 3.864 8.89847 3.78C8.49047 3.654 8.15747 3.528 7.89947 3.402C7.64147 3.276 7.41947 3.09 7.23347 2.844C7.04747 2.598 6.95447 2.277 6.95447 1.881C6.95447 1.293 7.16747 0.834001 7.59347 0.504001C8.01947 0.168001 8.57447 8.34465e-07 9.25847 8.34465e-07C9.95447 8.34465e-07 10.5155 0.168001 10.9415 0.504001C11.3675 0.834001 11.5955 1.296 11.6255 1.89H9.96047C9.94847 1.686 9.87347 1.527 9.73547 1.413C9.59747 1.293 9.42047 1.233 9.20447 1.233C9.01847 1.233 8.86847 1.284 8.75447 1.386C8.64047 1.482 8.58347 1.623 8.58347 1.809C8.58347 2.013 8.67947 2.172 8.87147 2.286C9.06347 2.4 9.36347 2.523 9.77147 2.655C10.1795 2.793 10.5095 2.925 10.7615 3.051C11.0195 3.177 11.2415 3.36 11.4275 3.6C11.6135 3.84 11.7065 4.149 11.7065 4.527C11.7065 4.887 11.6135 5.214 11.4275 5.508C11.2475 5.802 10.9835 6.036 10.6355 6.21C10.2875 6.384 9.87647 6.471 9.40247 6.471ZM18.5846 0.0900007L16.3436 6.408H14.4176L12.1766 0.0900007H13.8146L15.3806 4.86L16.9556 0.0900007H18.5846Z"
                fill="white"
              />
            </g>
          `;

        case this.type === "application/vnd.ms-powerpoint":
          return svg`
            <g transform="translate(0 6) scale(1.3)">
              <path
                d="M4.81502 2.034C4.81502 2.4 4.73102 2.736 4.56302 3.042C4.39502 3.342 4.13702 3.585 3.78902 3.771C3.44102 3.957 3.00902 4.05 2.49302 4.05H1.53902V6.318H1.6626e-05V5.96046e-07H2.49302C2.99702 5.96046e-07 3.42302 0.0870005 3.77102 0.261C4.11902 0.435 4.38002 0.675 4.55402 0.981C4.72802 1.287 4.81502 1.638 4.81502 2.034ZM2.37602 2.826C2.67002 2.826 2.88902 2.757 3.03302 2.619C3.17702 2.481 3.24902 2.286 3.24902 2.034C3.24902 1.782 3.17702 1.587 3.03302 1.449C2.88902 1.311 2.67002 1.242 2.37602 1.242H1.53902V2.826H2.37602ZM10.4312 2.034C10.4312 2.4 10.3472 2.736 10.1792 3.042C10.0112 3.342 9.75323 3.585 9.40523 3.771C9.05723 3.957 8.62523 4.05 8.10923 4.05H7.15523V6.318H5.61623V5.96046e-07H8.10923C8.61323 5.96046e-07 9.03923 0.0870005 9.38723 0.261C9.73523 0.435 9.99623 0.675 10.1702 0.981C10.3442 1.287 10.4312 1.638 10.4312 2.034ZM7.99223 2.826C8.28623 2.826 8.50523 2.757 8.64923 2.619C8.79323 2.481 8.86523 2.286 8.86523 2.034C8.86523 1.782 8.79323 1.587 8.64923 1.449C8.50523 1.311 8.28623 1.242 7.99223 1.242H7.15523V2.826H7.99223ZM15.7774 5.96046e-07V1.233H14.1034V6.318H12.5644V1.233H10.8904V5.96046e-07H15.7774ZM20.4198 6.318L19.1328 4.383L17.9988 6.318H16.2528L18.2778 3.105L16.2078 5.96046e-07H17.9988L19.2678 1.908L20.3838 5.96046e-07H22.1298L20.1228 3.186L22.2108 6.318H20.4198Z"
                fill="white"
              />
            </g>
          `;
        case this.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation":
          return svg`
            <g transform="translate(3 6) scale(1.3)">
              <path
                d="M4.81502 2.034C4.81502 2.4 4.73102 2.736 4.56302 3.042C4.39502 3.342 4.13702 3.585 3.78902 3.771C3.44102 3.957 3.00902 4.05 2.49302 4.05H1.53902V6.318H1.6626e-05V5.96046e-07H2.49302C2.99702 5.96046e-07 3.42302 0.0870005 3.77102 0.261C4.11902 0.435 4.38002 0.675 4.55402 0.981C4.72802 1.287 4.81502 1.638 4.81502 2.034ZM2.37602 2.826C2.67002 2.826 2.88902 2.757 3.03302 2.619C3.17702 2.481 3.24902 2.286 3.24902 2.034C3.24902 1.782 3.17702 1.587 3.03302 1.449C2.88902 1.311 2.67002 1.242 2.37602 1.242H1.53902V2.826H2.37602ZM10.4312 2.034C10.4312 2.4 10.3472 2.736 10.1792 3.042C10.0112 3.342 9.75323 3.585 9.40523 3.771C9.05723 3.957 8.62523 4.05 8.10923 4.05H7.15523V6.318H5.61623V5.96046e-07H8.10923C8.61323 5.96046e-07 9.03923 0.0870005 9.38723 0.261C9.73523 0.435 9.99623 0.675 10.1702 0.981C10.3442 1.287 10.4312 1.638 10.4312 2.034ZM7.99223 2.826C8.28623 2.826 8.50523 2.757 8.64923 2.619C8.79323 2.481 8.86523 2.286 8.86523 2.034C8.86523 1.782 8.79323 1.587 8.64923 1.449C8.50523 1.311 8.28623 1.242 7.99223 1.242H7.15523V2.826H7.99223ZM15.7774 5.96046e-07V1.233H14.1034V6.318H12.5644V1.233H10.8904V5.96046e-07H15.7774Z"
                fill="white"
              />
            </g>
          `;

        case this.type === "application/msword":
        case this.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        case this.type === "text/plain":
          return svg`
            <path
              d="M11.3333 12H2"
              stroke="white"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 9.33331H2"
              stroke="white"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.3333 6.66669H2"
              stroke="white"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M14 4H2" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
          `;
        case this.type === "application/pdf":
          return svg`
            <g transform="translate(3 6) scale(1.3)">
              <path
                d="M4.81499 2.034C4.81499 2.4 4.73099 2.736 4.56299 3.042C4.39499 3.342 4.13699 3.585 3.78899 3.771C3.44099 3.957 3.00899 4.05 2.49299 4.05H1.53899V6.318H-1.38916e-05V5.96046e-07H2.49299C2.99699 5.96046e-07 3.42299 0.0870005 3.77099 0.261C4.11899 0.435 4.37999 0.675 4.55399 0.981C4.72799 1.287 4.81499 1.638 4.81499 2.034ZM2.37599 2.826C2.66999 2.826 2.88899 2.757 3.03299 2.619C3.17699 2.481 3.24899 2.286 3.24899 2.034C3.24899 1.782 3.17699 1.587 3.03299 1.449C2.88899 1.311 2.66999 1.242 2.37599 1.242H1.53899V2.826H2.37599ZM7.9832 5.96046e-07C8.6492 5.96046e-07 9.2312 0.132001 9.7292 0.396C10.2272 0.660001 10.6112 1.032 10.8812 1.512C11.1572 1.986 11.2952 2.535 11.2952 3.159C11.2952 3.777 11.1572 4.326 10.8812 4.806C10.6112 5.286 10.2242 5.658 9.7202 5.922C9.2222 6.186 8.6432 6.318 7.9832 6.318H5.6162V5.96046e-07H7.9832ZM7.8842 4.986C8.4662 4.986 8.9192 4.827 9.2432 4.509C9.5672 4.191 9.7292 3.741 9.7292 3.159C9.7292 2.577 9.5672 2.124 9.2432 1.8C8.9192 1.476 8.4662 1.314 7.8842 1.314H7.1552V4.986H7.8842ZM16.2683 5.96046e-07V1.233H13.6943V2.565H15.6203V3.762H13.6943V6.318H12.1553V5.96046e-07H16.2683Z"
                fill="white"
              />
            </g>
          `;
      }
    }
  }

  override render() {
    return html`
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        ${svg`
        <g clip-path="url(#clip0_2001_2727)">
          <path
            d="M34.9998 7.95719V36C34.9998 38.2091 33.209 40 30.9998 40H9C6.79086 40 5 38.2091 5 36V4C5 1.79086 6.79086 0 9 0H26.3367L34.9998 7.95719Z"
            fill="${this.colors().back}"
          />
          <g filter="url(#filter0_d_2001_2727)">
            <path
              d="M34.9998 7.95719H27.3367C26.7844 7.95719 26.3367 7.50947 26.3367 6.95719V0L34.9998 7.95719Z"
              fill="${this.colors().fold}"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_2001_2727"
            x="23.3367"
            y="-1"
            width="12.6631"
            height="11.9572"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-1" dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2001_2727" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2001_2727" result="shape" />
          </filter>
          <clipPath id="clip0_2001_2727">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
        <g transform="translate(7 18)">${this.icon()}</g>
      `}
      </svg>
    `;
  }
}
